export const ACCESS_TOKEN = "accessToken";
export const IS_WALLET_CONNECTED = "isWalletConnected";
export const EXPIRED_TOKEN_EVENT = "expiredTokenEvent";
